import { providerNames, } from "../../../../../server/db/schema/intProvider.js";
export const tierCountScopeNames = {
    line: "Osobno dla każdego zdjęcia",
    "category-format": "Ten format w całej kategorii",
    "category-all": "Wszystkie formaty w kategorii",
};
export const constant = (value) => ({
    type: "constant",
    value: value,
});
const isConstant = (provider) => typeof provider === "object" &&
    provider !== null &&
    provider.type === "constant";
export const isSimpleTiers = (provider) => typeof provider === "object" &&
    provider.type === "per-item-tiers-provider" &&
    Array.isArray(provider.tiers) &&
    provider.tiers.every((tier) => isConstant(tier.price)) &&
    isConstant(provider.priceForAllNext);
/**
 * @returns price per item when the provider is a single price per item
 */
export const fixedPriceOf = (provider) => {
    if (typeof provider === "number")
        return provider;
    if (provider.type === "per-item" && isConstant(provider.value))
        return provider.value.value;
    return undefined;
};
export const detectPriceMode = (provider) => {
    if (fixedPriceOf(provider) !== undefined)
        return "fixed";
    if (isSimpleTiers(provider))
        return "tiers";
    return "advanced";
};
/**
 * Converts the provider so it can be edited in the given mode, keeping as much as possible.
 */
export const convertToMode = (provider, mode) => {
    const fixedPrice = fixedPriceOf(provider);
    const basePrice = fixedPrice !== null && fixedPrice !== void 0 ? fixedPrice : (isSimpleTiers(provider) ? provider.priceForAllNext.value : 10);
    switch (mode) {
        case "fixed":
            return basePrice;
        case "tiers":
            return {
                type: "per-item-tiers-provider",
                countScope: "category-format",
                tiers: [{ next: 3, price: constant(0) }],
                priceForAllNext: constant(basePrice),
            };
        case "advanced":
            return typeof provider === "number" ?
                { type: "per-item", value: constant(provider) }
                : provider;
    }
};
/**
 * Tier sizes (`next`) as the last item number included in each tier, e.g. [3, 2] -> [3, 5]
 */
export const tierUpperBounds = (tiers) => {
    let bound = 0;
    return tiers.map((tier) => (bound += tier.next));
};
/**
 * Validates tier bounds
 * @returns error message or undefined when the tiers are valid
 */
export const validateTiers = (tiers) => {
    if (tiers.some((tier) => !Number.isInteger(tier.next) || tier.next < 1))
        return "Każdy próg musi obejmować co najmniej 1 sztukę, a progi muszą rosnąć.";
    return undefined;
};
const formatPrice = (price) => price === 0 ? "gratis" : `${price} zł/szt.`;
const describeTiers = (provider) => {
    var _a;
    const bounds = tierUpperBounds(provider.tiers);
    const parts = provider.tiers.map((tier, index) => {
        const from = index === 0 ? 1 : bounds[index - 1] + 1;
        const to = bounds[index];
        const range = index === 0 ? `pierwsze ${to} szt.`
            : from === to ? `${from}. szt.`
                : `${from}–${to} szt.`;
        return `${range} ${formatPrice(tier.price.value)}`;
    });
    parts.push(`kolejne ${formatPrice(provider.priceForAllNext.value)}`);
    const summary = parts.join(", ");
    const scope = (_a = provider.countScope) !== null && _a !== void 0 ? _a : "line";
    return (summary.charAt(0).toUpperCase() +
        summary.slice(1) +
        (scope === "line" ? "" : ` (${tierCountScopeNames[scope].toLowerCase()})`));
};
/**
 * @returns a short, human readable description of the price
 */
export const describePrice = (provider) => {
    var _a;
    const fixedPrice = fixedPriceOf(provider);
    if (fixedPrice !== undefined)
        return `${fixedPrice} zł/szt.`;
    if (isSimpleTiers(provider))
        return describeTiers(provider);
    if (typeof provider === "object")
        return `Formuła: ${(_a = providerNames.get(provider.type)) !== null && _a !== void 0 ? _a : provider.type}`;
    return "";
};
